/** Set to true when Farsi/Persian should be offered in the UI again. */
export const FARSI_ENABLED = false;

export const LANGUAGE_OPTIONS = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'es', name: 'Español' },
  ...(FARSI_ENABLED ? [{ code: 'fa' as const, name: 'فارسی' }] : []),
];

export const DEFAULT_AVAILABLE_LANGUAGES = LANGUAGE_OPTIONS.map((l) => l.code);

export const SUPPORTED_I18N_LANGUAGES = FARSI_ENABLED
  ? (['en', 'fr', 'es', 'fa'] as const)
  : (['en', 'fr', 'es'] as const);

export function isLanguageEnabled(code: string): boolean {
  return code !== 'fa' || FARSI_ENABLED;
}

/** Strip disabled languages (e.g. fa) from account or API language lists. */
export function filterEnabledLanguages(codes: string[]): string[] {
  const filtered = codes.filter(isLanguageEnabled);
  return filtered.length > 0 ? filtered : [...DEFAULT_AVAILABLE_LANGUAGES];
}
